var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-config-provider',{attrs:{"locale":_vm.locale}},[_c('div',[_c('head-bar',{staticClass:"head"}),_c('left-bar',{staticClass:"left"}),_c('div',{staticClass:"right"},[_c('router-view')],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }